import React from 'react';

import { Assessment } from '@/services/assessmentsAPI';
import Card from '@/components/Card';
import Stack from '@/components/Stack';
import Chip from '@/components/Chip';
import { Small } from '@/components/Typography';

interface AssessmentCardProps {
  assessment: Assessment;
  isSelected: boolean;
  onClick: () => void;
}

const AssessmentCard: React.FC<AssessmentCardProps> = ({
  assessment,
  isSelected,
  onClick,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getResultStatusColor = (
    resultStatus: string | null,
  ): 'success' | 'error' | 'warning' | 'primary' => {
    switch (resultStatus) {
      case 'passed':
        return 'success';
      case 'failed':
        return 'error';
      case 'for_review':
        return 'warning';
      default:
        return 'primary';
    }
  };

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      style={{ cursor: 'pointer', width: '100%' }}
    >
      <Card
        changeStyle={{ padding: '16px' }}
        css={{
          border: isSelected ? '2px solid #007bff' : '1px solid #e0e0e0',
          backgroundColor: isSelected ? '#f0f8ff' : '#fff',
          width: '100%',
          '&:hover': { backgroundColor: '#f9f9f9' },
        }}
      >
        <Stack vertical gap={8}>
          <Stack gap={8}>
            <Small color="light" weight="semibold">
              ID:
            </Small>
            <Small>{assessment.external_id}</Small>
          </Stack>
          <Stack gap={8}>
            <Small color="light" weight="semibold">
              User:
            </Small>
            <Small>{assessment.user_id}</Small>
          </Stack>
          <Stack gap={8}>
            <Small color="light" weight="semibold">
              Skill:
            </Small>
            <Small>{assessment.skill_id}</Small>
          </Stack>
          <Stack justify="apart" align="center">
            <Small>{formatDate(assessment.created_at)}</Small>
            {assessment.result_status && (
              <Chip
                color={getResultStatusColor(assessment.result_status)}
                label={assessment.result_status.replace(/_/g, ' ')}
              />
            )}
          </Stack>
        </Stack>
      </Card>
    </div>
  );
};

export default AssessmentCard;
